import React from 'react';

function NotFoundPage() {
    return (
        <div className="page">
            <div className='notfound-header'>
                <h1>404</h1>
                <h2>Page not found</h2>
            </div>
        </div>
    );
}

export default NotFoundPage;